import React from 'react';
import _ from 'lodash';
import ZuoraLoading from '../ZuoraLoading/ZuoraLoading';

// IMPORTANT: this callback component will be loaded WITHIN the Zuora iframe!
class ZuoraCallback extends React.Component {
  constructor() {
    super();
    this.response = {};
    this.extractPaymentResponse = this.extractPaymentResponse.bind(this);
  }

  componentDidMount() {
    try {
      const response = this.extractPaymentResponse();
      window.parent.handleZuoraResponse(response);  // defined in ZuoraSubmitButton
    } catch (error) {
      window.parent.submitFail({ genericError: error });  // defined in ZuoraInline
      console.error(error); // eslint-disable-line
    }
  }

  extractPaymentResponse() {
    const aResponse = location.search.slice(1).split('&');
    const response = {};
    _.each(aResponse, (error) => {
      const [key, val] = error.split('=');
      response[key] = val;
    });
    this.response = response;
    return response;
  }

  render() {
    return (<ZuoraLoading />);
  }
}

export default ZuoraCallback;



/** WEBPACK FOOTER **
 ** ./src/components/zuora/ZuoraCallback/ZuoraCallback.js
 **/